@if (formula && form) {
  <mat-card>
    <div style="display: flex">
      <div>
        <h3 i18n="label editor@@label_editor">Label Editor</h3>
        <div>Attached to formula: {{ form.collectionName.display }} </div>
        <div>Collection: {{ form.collectionName.collection }} </div>
      </div>
      <div style="margin-left: 10vw">
        <h3 i18n="assigned surveys@@assigned_surveys">Assigned surveys</h3>
        @if (formula.kobo_surveys && formula.kobo_surveys.length > 0) {
          <div>
            @for (survey of formula.kobo_surveys; track survey) {
              <div>
                {{ survey.surveyName }}
              </div>
            }
          </div>
        }
        @if (!formula.kobo_surveys || formula.kobo_surveys.length === 0) {
          <div i18n="please assign a survey@@please_assign_survey">
        Please assign a survey in the formula editor
      </div>
        }
      </div>
    </div>
    <p i18n="fields@@fields">{{ form.fields.length }} Fields</p>
    <div>
      @for (field of form.fields; track field; let fieldIndex = $index) {
        <app-form-field-label
          [formField]="field"
          [fieldindex]="fieldIndex"
          (changeLabelEvent)="changeLabel($event)"
        ></app-form-field-label>
      }
    </div>
    <div style="display: flex">
      <div>
        <div>
          <button mat-button (click)="saveFormula()" i18n="save formula@@save_formula">Save labels</button>
        </div>
      </div>
      <label style="flex: 1 1 auto"></label>
      <div>
        <button mat-raised-button color="warn" (click)="resetLabels()" i18n="deleteformula@@delete_formula">
        Reset labels
      </button>
      </div>
    </div>
  </mat-card>
}
